import React from "react";
import { useTranslation } from "react-i18next";
import { IoLogoWhatsapp } from "react-icons/io";
import useContactAvailable from "../../Hooks/useContactAvailable";

/**
 * "Questions? We reply on WhatsApp" block in the nav drawer.
 *
 * Outside the hours the owner set in the partner app the promise in the copy is not true, so
 * the button says ~Offline and does not open a chat. Telling a buyer they will get a reply and
 * then not replying costs more than the tap did.
 */
const Whatsappquestions = ({ phone }) => {
  const { t } = useTranslation();
  const { offline } = useContactAvailable();
  const href = phone ? `https://wa.me/91${phone}` : undefined;
  return (
    <>
      <div className="m-[10px_16px_4px] bg-[#F4F5FF] border border-[#E8EAF0] rounded-[12px] p-[13px] text-center">
        <div className="text-[12.5px] text-[#545454] mb-3">
          {offline ? t("waQuestions.offline") : t("waQuestions.online")}
        </div>
        {offline ? (
          <span
            aria-disabled="true"
            className="bg-[#9CA3AF] text-white inline-flex items-center gap-[7px] text-[13px] font-[400] py-[8px] px-[13px] rounded-[9999px] cursor-not-allowed no-underline opacity-80"
          >
            <IoLogoWhatsapp /> {t("waQuestions.offlineChip")}
          </span>
        ) : (
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="bg-[#25D366] text-white inline-flex items-center gap-[7px] text-[13px] font-[400] py-[8px] px-[13px] rounded-[9999px] cursor-pointer no-underline"
          >
            <IoLogoWhatsapp /> WhatsApp
          </a>
        )}
      </div>
    </>
  );
};
export default Whatsappquestions;
